// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__ZBfzx","title":"FrontImage_title__p0CPH"};